export const Base = {
  lg: '24px',
  xs: '16px'
};